import { render, staticRenderFns } from "./MWPoster.vue?vue&type=template&id=d4f3c13c&scoped=true"
import script from "./MWPoster.vue?vue&type=script&lang=js"
export * from "./MWPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f3c13c",
  null
  
)

export default component.exports